module.exports = __webpack_public_path__ + "5f83a63e2fea7fb47ca99b4163ef9b42.png";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/ueno.png
// module id = 418
// module chunks = 0